import ClassHelper from '../ClassHelper';

class ObjectServicePrice extends ClassHelper {
  constructor({ price, objectPrice, minAge, maxAge } = {}) {
    super(...arguments);
    this.price = price;
    this.objectPrice = objectPrice;
    this.minAge = minAge;
    this.maxAge = maxAge;
  }
}

export default ObjectServicePrice;